import { render } from "./Historique.vue?vue&type=template&id=ab4aa134"
import script from "./Historique.vue?vue&type=script&lang=js"
export * from "./Historique.vue?vue&type=script&lang=js"
script.render = render

export default script